import React, { useContext, useEffect } from 'react';
import { graphql } from 'gatsby';

import FadeTransition from './../components/fadeTransition';
import { context } from './../components/context';

import Registration from '../components/preRegistrationHome';
import WeeklyTemplate from '../components/weeklyTemplate';
import ClientOnly from '../components/ClientOnly';

const Index = ({ data, location }) => {
  const { registration } = data.sanityCampaign;
  const appContext = useContext(context);
  const { currentWeek, setDisplayWeek, displayWeek, content } = appContext;

  useEffect(() => {
    setDisplayWeek(currentWeek);
  }, [currentWeek, setDisplayWeek]);

  return (
    <ClientOnly>
      {displayWeek === 0 ? (
        <FadeTransition>
          <Registration
            content={{ registration, content }}
            location={location}
          />
        </FadeTransition>
      ) : (
        <WeeklyTemplate location={location} />
      )}
    </ClientOnly>
  );
};

export const query = graphql`
  query IndexQuery {
    sanityCampaign(_id: { eq: "c0b30cde-9c45-489e-aab1-35b714d7c2e1" }) {
      registration {
        _rawContent
        title
        image {
          asset {
            gatsbyImageData(placeholder: BLURRED, width: 800)
          }
        }
      }
    }
  }
`;

export default Index;
